<template>
  <Modal v-model="barcodePromptModal" :title="$t('key1006298')" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="barcodePromptChange">
    <h2 class="mb10">
      {{ $t('key1006299') }}<span>{{orderTypeName}}</span>{{ $t('key1006300') }}
      <span class="distributorThemeColor cursor" @click="toCommodityList">{{ $t('key1006301') }}</span>
      {{ $t('key1006302') }}
    </h2>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <div style="text-align: right;">
        <Button type="primary" @click="barcodePromptModal = false">{{ $t('key1000316') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {getDataSetMap} from "@/utils/common";

export default {
  name: "barcodePromptModal",
  mixins: [Mixin],
  props: {
    orderType: {
      type: String,
      default: 'TEMU_P'
    }
  },
  data() {
    let v = this;
    return {
      barcodePromptModal: false,
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 200,
          render(h, params) {
            let skuImgPath = params.row._productInfo.primaryImage;
            let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
            let imgPath = skuImgPath ? skuImgPath : spuImgPath;
            let productGoodsSpecificationList = params.row._productInfo.productGoodsSpecificationList || [];
            let spec = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row._productInfo._spuInfo.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row._productInfo.ymsSku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        }
      ],
      tableData: [],
      orderTypeName: ''
    };
  },
  methods: {
    // 初始化数据
    barcodePromptData(data) {
      let v = this;
      let ymsProductGoodsIds = [];
      let list = [];
      if (data && data.length > 0) {
        data.map((item) => {
          list.push({
            ymsProductGoodsId: item
          });
          ymsProductGoodsIds.push(item);
        });
        if (ymsProductGoodsIds.length > 0) {
          (async () => {
            v.tableData = await v.getProductInfoByIds(ymsProductGoodsIds, list);
            let enumMap = await getDataSetMap('OrderTypeBarcodeEnum');
            v.orderTypeName = enumMap[v.orderType].name || '';
            v.barcodePromptModal = true;
          })();
        }
      }
    },
    // 跳转到我的商品
    toCommodityList() {
      let v = this;
      const {href} = v.$router.resolve({
        path: '/commodityList'
      });
      window.open(href, '_blank');
    },
    // 监听弹窗
    barcodePromptChange(value) {
      if (!value) {
        this.tableData = [];
      }
    }
  }
};
</script>

<style scoped>

</style>